/**
 * A CLIENT ON PAUSE (redesign register D6, A13; record 11; brief FE-FOUNDATION section 13).
 *
 * An agency is paused while `paused_until` is today or later: the health engine gives it no
 * colour and the one reason line "Paused until 12 October 2026" until the day after the date
 * (record 11), and the pages leave it out of the attention lists at once rather than waiting
 * the minute the engine takes.
 *
 * The date reads in the ENGINE'S form, the month spelled out (`health/calendar.ts` `formatDay`
 * since commit c02b08f3), so a coach reads one date style in every stored reason and on every
 * page.
 */
export const PAUSED_UNTIL_FIELD = 'paused_until';

/** `YYYY-MM-DD` days compare as text. A missing date is no pause. */
export function isPaused(pausedUntil: string | null | undefined, today: string): boolean {
  if (pausedUntil === null || pausedUntil === undefined || pausedUntil.length < 10) return false;
  return pausedUntil.slice(0, 10) >= today;
}

/** "12 October 2026": the engine's `formatDay`, read in UTC so the day never shifts. */
export function pauseDateWords(day: string): string {
  const [year, month, date] = day.slice(0, 10).split('-').map(Number) as [number, number, number];
  return new Intl.DateTimeFormat('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    timeZone: 'UTC',
  }).format(new Date(Date.UTC(year, month - 1, date)));
}

/** "Paused until 12 October 2026" (record 11; the words register D6 and A13 quote). */
export function pausedUntilWords(day: string): string {
  return `Paused until ${pauseDateWords(day)}`;
}

/** The toast after "Pause" (open question Q-FND-12, decided): "<Client> paused until <date>". */
export function pausedToastTitle(clientName: string, day: string): string {
  return `${clientName} paused until ${pauseDateWords(day)}`;
}
